<template>
  <form class="form-signin" 
  @submit="login()"
  v-if="show">
    <h1 class="h3 mb-3 font-weight-normal">로그인이 필요합니다</h1>
    <label for="inputEmail" class="sr-only">메일주소</label>
    <input type="email" id="inputEmail" class="form-control" placeholder="Email address" required="" autofocus=""
    v-model="form.username">
    <label for="inputPassword" class="sr-only">패스워드</label>
    <input type="password" id="inputPassword" class="form-control" placeholder="Password" required=""
    v-model="form.password">
    <div class="checkbox mb-3">
      <label>
        <!-- <input type="checkbox" value="remember-me"> 자동으로 로그인합니다 -->
      </label>
    </div>
    <button class="btn btn-lg btn-primary btn-block" type="submit">로그인</button>
    <p class="mt-5 mb-3 text-muted">© 2018</p>
  </form>
</template>

<script>
export default {
  name: 'Login',
  props: {
    token: String
  },
  data () {
    return {
      show: true,
      form: {}
    }
  },
  methods: {
    login () {
      event.preventDefault();
      this.$http.post('auth', this.form)
      .then(result => {
        if (result.data.token) {
          this.$emit('successfulLogin', result.data.token)
          this.form = {}
        }        
      })      
    }
  }
}
</script>

<style scoped>
html,
body {
  height: 100%;
}

body {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

</style>

